import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Logo from "../../Assets/images/logo.png";
import AllFormFields from "../../Common/AllFormFields";
import { Loader } from "../../Common/Loader";
import { ErrorModel } from "../../Model/ErrorModel";
import { SuccessModel } from "../../Model/SuccessModel";
import { getAssistantForm } from "../../Redux/Slice/Form/GetAssistantFormSlice";
import { uploadTalkDetailForm } from "../../Redux/Slice/Talk/UploadTalkDetailFormSlice";
import CheckMarkIcon from "../../Assets/svgs/CheckMarkIcon";
import ReactQuill from "react-quill";

const Form = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [successModal, setSuccessModal] = useState({
    visible: false,
    message: "",
  });
  const [errorModal, setErrorModal] = useState({ visible: false, message: "" });
  const { assistantFormData, loading } = useSelector(
    (state) => state?.assistantForm
  );

  const splitPath = location?.pathname?.split("/");
  const assistantId = splitPath[splitPath?.length - 1];

  const showSuccessMessage = (message, callback) => {
    setSuccessModal({
      visible: true,
      message: message ?? "Something went wrong, please try again later!",
    });

    setTimeout(() => {
      setSuccessModal({ visible: false, message: "" });
      if (typeof callback === "function") {
        callback();
      }
    }, 3000);
  };

  const showErrorMessage = (message, callback) => {
    setErrorModal({
      visible: true,
      message: message ?? "Something went wrong, please try again later!",
    });

    setTimeout(() => {
      setErrorModal({ visible: false, message: "" });
      if (typeof callback === "function") {
        callback();
      }
    }, 2000);
  };

  const redirectToTalk = (responseData) => {
    if (responseData?.assistantId && responseData?.callToken) {
      navigate(
        `/talk/${responseData?.assistantId}/${responseData?.callToken}`,
        {
          state: { isFromForm: true },
        }
      );
    } else {
      navigate("/");
    }
  };

  const onSubmit = async (formData) => {
    const payloadFormData = new FormData();
    payloadFormData.append("formId", assistantFormData?.data?.id);
    formData?.forEach((e) => {
      if (e?.type == "phone" && e?.value) {
        payloadFormData.append(e?.label, `+${e?.value?.replace(/\D/g, "")}`);
      } else if (e?.value) {
        payloadFormData.append(e?.label, e?.value);
      }
    });
    setIsLoading(true);
    const result = await dispatch(
      uploadTalkDetailForm({ body: payloadFormData, isSourceEmail: false })
    );
    if (
      uploadTalkDetailForm.fulfilled.match(result) &&
      result?.payload?.success === true
    ) {
      setIsLoading(false);
      showSuccessMessage(
        "Form successfully Submitted - please click to continue",
        () => redirectToTalk(result?.payload?.data)
      );
    } else {
      setIsLoading(false);
      showErrorMessage(result?.payload?.error?.message);
    }
  };

  useEffect(() => {
    dispatch(getAssistantForm(assistantId));
  }, [assistantId]);

  return (
    <section className="layoutContainer layoutContainer--full">
      {(isLoading || loading) && <Loader />}
      {errorModal.visible && <ErrorModel message={errorModal.message} />}
      {successModal.visible && <SuccessModel message={successModal.message} />}
      <div className="layoutGrid">
        <div className="page page__full">
          <div className="page__head">
            <div className="page__head__logo">
              <img
                src={assistantFormData?.data?.customer?.logo ?? Logo}
                alt="Logo | Vox App"
                style={{ height: "30px" }}
              />
            </div>
          </div>
          <div className="page__body">
            <div className="CreateformBoxChat">
              <div className="CreateformBoxChat__steps">
                <div
                  className={`CreateformBoxChat__steps__item ${
                    step != 1 ? "completed" : "active"
                  } `}
                >
                  <div className="infoDetail">
                    <h4 className="title">Step 1</h4>
                    <p className="para">Instructions</p>
                  </div>
                  {step == 1 ? (
                    <div className="count">1</div>
                  ) : (
                    <div className="count">
                      <CheckMarkIcon />
                    </div>
                  )}
                </div>
                <div
                  className={`CreateformBoxChat__steps__item ${
                    step == 2 ? "active" : step > 2 ? "completed" : ""
                  } `}
                >
                  <div className="infoDetail">
                    <h4 className="title">Step 2</h4>
                    <p className="para">Fill Form Details</p>
                  </div>
                  {step <= 2 ? (
                    <div className="count">2</div>
                  ) : (
                    <div className="count">
                      <CheckMarkIcon />
                    </div>
                  )}
                </div>
              </div>
              <div className="CreateformBoxChat__data">
                {step == 1 ? (
                  <div className="CreateformBoxChat__form">
                    <div className="CreateformBoxChat__form__head">
                      <h3 className="title title--h4">Instructions</h3>
                      <p className="para ql--preview">
                        <ReactQuill
                          value={assistantFormData?.data?.instructions}
                          readOnly={true}
                          theme={"bubble"}
                        />
                      </p>
                    </div>
                    <div className="btn__group">
                      <button
                        className="btn btn__primary"
                        onClick={() => setStep(2)}
                      >
                        Next
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className="CreateformBoxChat__form">
                    <div className="CreateformBoxChat__form__head">
                      <h3 className="title title--h4">Fill the details</h3>
                    </div>
                    <AllFormFields
                      fieldData={
                        Array.isArray(assistantFormData?.data?.fields)
                          ? assistantFormData?.data?.fields?.filter(
                              (field) => field?.visible
                            )
                          : []
                      }
                      showErrorMessage={showErrorMessage}
                      onSubmit={onSubmit}
                      submitBtnText={"Submit"}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Form;
